import React from 'react';
import { PropTypes } from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const GeneralCellRenderer = ({ value }) => (
  <div>{ value || 'N/A' }</div>
);

GeneralCellRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
};

GeneralCellRenderer.defaultProps = {
  value: 'N/A'
};
